// src/data/VisitedPlaces.js

export const VISITED_PLACES = {
  withVideo: [
    // -------------------------
    // UNITED STATES (with video)
    // -------------------------
    "usa",
    "unitedstates",
    "us",
    "nevada",
    "oregon",
    "southdakota",
    "idaho",
    "arizona",
    "newjersey",
    

    // -------------------------
    // COLORADO (with video)
    // -------------------------
    "colorado",
    "aspen",
    "buenavista",
    "breckenridge",
    "canyoncity",
    "coloradosprings",
    "denver",
    "frisco",
    "fruita",
    "georgetown",
    "glenwoodsprings",
    "golden",
    "idahosprings",
    "manitou",
    "morrison",
    "mosca",
    "ouray",
    "rifle",
    "steamboat",
    "telluride",
    "vail",
    "grandlake",

    // -------------------------
    // PUERTO RICO (with video)
    // -------------------------
    "aguadilla",
    "arecibo",
    "caborojo",
    "utuado",
    "jayuya",
    "isabela",
    "lajas",
    "borinquen",
    "rincon",
    "sanjuan",
    "aguada",
    "anasco",
    "adjuntas",
    "sansebastian",
    "guanica",
  ],

  noVideo: [
    // -------------------------
    // UNITED STATES (no video)
    // -------------------------
    "utah",
    "wyoming",

    // -------------------------
    // PUERTO RICO (no video)
    // -------------------------
    
    "vieques",

    // -------------------------
    // COLORADO (no video)
    // -------------------------
    // (none yet)
  ],
};
